import { render, staticRenderFns } from "./TaskPageSkeleton.vue?vue&type=template&id=625bd7c9&scoped=true&"
var script = {}
import style0 from "./TaskPageSkeleton.vue?vue&type=style&index=0&id=625bd7c9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625bd7c9",
  null
  
)

export default component.exports